import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';
import { applyRequestMiddleware } from './utils/fetch';

const auth = new Auth( {
  authority: idURL,
  // uncomment for local dev
  // companyId: '2eddede7-12e0-493a-ba36-3940b96b1cac'
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} ),
        'company-id': auth.state.claims.company_id,
        'x-company-id': auth.state.claims.company_id,
    };

    if ( auth.state.access_token ) {
        options.headers.authorization = `Bearer ${ auth.state.access_token }`;
    }
 } );
